import * as React from 'react';
import cx from 'classnames';

import { PRINTABLE_DATASHEET_FIELD_ID } from '../datasheet-printing-settings';

import './datasheet-item.styles.scss';

export type DatasheetItemProps = React.PropsWithChildren<{
  style: React.CSSProperties;
  displayType?: "block" | "flex";
  className?: string;
}>;

export const DatasheetItem: React.FC<DatasheetItemProps> = (props) => {
  const { children, style, displayType, className } = props;

  return (
    <div 
      style={style}
      data-printable-element={PRINTABLE_DATASHEET_FIELD_ID}
      className={cx("DatasheetsDatasheetItem", `DatasheetsDatasheetItem--${displayType}`, className)}
    >
      {children}
    </div>
  );
};